module.exports = __webpack_public_path__ + "fonts/nunito-sans-regular.fb98ed17.ttf";